<template>
  <div class="layout">
    <div class="layout_nav">
      <Nav v-bind="getRol"></Nav>
    </div>
    <div class="layout_center">
      <v-container fluid>
        <v-row>
          <v-col class="pa-0">
            <Welcome v-bind="getUser"></Welcome>
          </v-col>
          <v-col class="pa-0 py-5" md="auto">
            <div v-for="item in getNotifyDeviceShowAlert" :key="item._id">
              <NotifyAlert
                :Item="item"
                :Flag="true"
                :Text="item.register"
              ></NotifyAlert>
            </div>
            <Snackbar
              v-bind:visible="getAlert.snackbar"
              v-bind:text="getAlert.text"
            ></Snackbar>
            <div class="ctn_indicator">
              <!-- indicador -->
              <Indicator
                v-bind:active="getPanel.active"
                v-bind:inactive="getPanel.inactive"
              ></Indicator>
              <!-- btn crear  -->
              <div class="ctn_btn_new">
                <v-btn
                  class="btn_new"
                  @click.stop="takeFlag = true"
                  color="primary"
                >
                  <v-icon>mdi-chip</v-icon>
                  <span>
                    Lectura masiva
                  </span>
                </v-btn>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
      <!-- tabla de datos -->
      <TableComp></TableComp>
      <p></p>

      <TakeReadAll :visible="takeFlag" @close="takeFlag = false"></TakeReadAll>
    </div>
  </div>
</template>
<script>
import Nav from "@/components/Nav.vue";
import TableComp from "@/components/device/Table.vue";
import Welcome from "@/components/Welcome.vue";
import Indicator from "@/components/Indicator.vue";
import TakeReadAll from "@/components/device/TakeReadAll.vue";
import Snackbar from "@/components/Snackbar.vue";
import NotifyAlert from "@/components/notify/NotifyAlert.vue";
import { mapGetters } from "vuex";

export default {
  name: "DeviceHome",
  components: {
    Nav,
    TableComp,
    Welcome,
    Indicator,
    TakeReadAll,
    Snackbar,
    NotifyAlert,
  },
  data() {
    return {
      takeFlag: false,
    };
  },
  computed: {
    ...mapGetters([
      "getUser",
      "getPanel",
      "getAlert",
      "getRol",
      "getNotifyDeviceShowAlert",
    ]),
  },
};
</script>
<style lang="scss">
.style_map {
  display: flex;
  height: 350px !important;
  z-index: 1;
  margin-bottom: 15px;
}
.ctn_map_market {
  display: flex;
  flex-direction: row;
  .ctn_market_col {
    flex: 1 1 auto;
    &._icon {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 40px;
    }
    img {
      width: 32px;
      height: 32px;
      object-fit: contain;
    }
    .copy {
      display: flex;
      flex-direction: column;
      padding: 0 10px;
      span {
        &.device_active {
          text-transform: uppercase;
          font-size: 0.6rem;
          border-radius: 2px;
          padding: 2px;
          background-color: #008000;
          color: #fff;
        }
        &.device_inactive {
          text-transform: uppercase;
          font-size: 0.6rem;
          border-radius: 2px;
          padding: 2px;
          background-color: #fc3d21;
          color: #fff;
        }
      }
    }
  }
}
</style>
